import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  Button,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

// Components.
import SortableTable from '../../shared/Tables/SortableTable';

const ExpandableSectionWithTable = ({
  title,
  open = false,
  fetching = false,
  headCells,
  rows,
  RowRenderer,
  onAddNew,
  addButtonLabel,
  children,
  ...props
}) => {
  const [expanded, setExpanded] = useState(open);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Card style={{ marginTop: '24px' }}>
      <CardHeader
        className='cursor-pointer'
        title={
          <span>
            <span>{title}</span>
            <span className='float-right'>
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </span>
          </span>
        }
        onClick={toggleExpand}
      />
      <Divider />
      <CardContent style={{ padding: `${expanded ? '20px' : 0}`, overflowY: 'auto' }}>
        <Collapse in={expanded}>
          {onAddNew && (
            <Button
              className={'colored-element create'}
              variant='contained'
              onClick={onAddNew}
              style={{ marginBottom: '10px' }}
            >
              {addButtonLabel || 'Add New'}
            </Button>
          )}

          {children}

          {fetching ? (
            <Skeleton animation='pulse' variant='rect' height='100px' width='100%' component='div' />
          ) : (
            <SortableTable
              headCells={headCells}
              rows={rows}
              RowRenderer={RowRenderer}
              disableSort
            />
          )}
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default ExpandableSectionWithTable;